import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "initials",
})
export class InitialsPipe implements PipeTransform {
  transform(user: {
    firstName: string | null;
    lastName: string | null;
    displayName?: string | null;
  }): string {
    const firstCharFirstName = user.firstName ? user.firstName[0] : "";
    const firstCharLastName = user.lastName ? user.lastName[0] : "";
    const nameInitials = firstCharFirstName + firstCharLastName;
    let initials = nameInitials;
    if (!initials) {
      if (user.displayName) {
        initials = this.guessInitialsFromDisplayName(user.displayName);
      } else {
        initials = "NN";
      }
    }
    return initials;
  }

  guessInitialsFromDisplayName(displayName: string) {
    let initials: string;
    let parts = displayName.split(" ").filter((p) => Boolean(p));
    if (parts.length > 1) {
      initials = parts[0][0] + parts[1][0];
    } else {
      parts = displayName.split(/[\.,\-_]/).filter((p) => Boolean(p));
      initials = parts.length > 1 ? parts[0][0] + parts[1][0] : parts[0][0];
    }
    if (initials[0] === "(") {
      // only the company name is in the display name
      initials = "NN";
    }
    return initials;
  }
}
